// extracted by mini-css-extract-plugin
export var lg = "_1q-4";
export var md = "_1q-3";
export var sm = "_1q-2";
export var xs = "_1q-1";
export var xxs = "_1q-0";